export const getErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (typeof error?.message === 'string') return error.message;
  if (typeof error?.response?.data?.message === 'string') return error.response.data.message;
  if (typeof error?.response?.data === 'string') return error.response.data;
  if (typeof error?.data?.message === 'string') return error.data.message;
  try {
    return JSON.stringify(error);
  } catch {
    return fallback;
  }
};
